<template>
    <Card class="social-card social-card-active" content-spacing="none" v-if="variant=='active'">
        <div class="social-card-thumb"></div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-labels">
            <slot name="social-card-labels" class="social-card-labels-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-left">
                <Button variant="icon-wrap"><svgicon name="delete" height="1.5rem"></svgicon></Button>
            </div>
            <div class="float-right">
                <Button variant="icon-wrap"><svgicon name="edit" height="1.5rem"></svgicon></Button>
            </div>
        </div>
        <div class="social-card-info">
            <div class="row">
                <div class="col-xl">
                    <div class="label-text">Shared by 24/78</div>
                    <Avatars></Avatars>
                </div>
                <div class="col-xl">
                    <div class="label-text">Date</div>
                    <div class="width-100 relative">
                        <div class="start-date">02-04-2019 / 16:31</div>
                        <div class="expiry-time">03-04-2019 / 12:55</div>
                    </div>
                </div>
            </div>
        </div>
    </Card>

    <Card class="social-card social-card-placeholder" content-spacing="none" v-else-if="variant === 'placeholder'">
      <div class="social-card-user-info">
        <div class="width-100 relative break-after">
          <div class="float-left">
            <skeleton variant="avatar"></skeleton>
          </div>
          <div class="float-left user-info-content">
            <div class="width-100 relative height-100">
              <div class="flex-content">
                <div class="width-100">
                  <div class="user-info-content-name">
                    <skeleton variant="text" display="small"></skeleton>
                  </div>
                  <div class="user-info-content-date">
                    <skeleton variant="text" display="small"></skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="social-card-thumb wrapper">
        <skeleton variant="image" v-bind:style="{ height: this.getRandomInt(3, 9) + 'rem'}"></skeleton>
      </div>
      <div class="social-card-text">
          <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            <skeleton v-for="index in getRandomInt(1, 4)" :key="index" variant="text" display="small"></skeleton>
          </slot>
      </div>
    </Card>

    <Card class="social-card social-card-input" content-spacing="none" v-else-if="variant=='input' || variant == 'pinned'">
        <div class="social-card-user-info">
            <div class="width-100 relative break-after">
                <div class="float-left">
                    <slot name="social-card-user-avatar"></slot>
                </div>
                <div class="float-left user-info-content">
                    <div class="width-100 relative height-100">
                        <div class="flex-content">
                            <div class="width-100">
                                <div class="user-info-content-name">
                                  <slot name="social-card-user-info-name"></slot>
                                </div>
                                <div class="user-info-content-date">
                                  <slot name="social-card-user-info-date"></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="social-card-thumb wrapper">
          <div v-if="enclosures.length > 1">
            <div class="slide prev" @click="prev">
              <span class="arrow left"></span>
              <span class="arrow left shadow"></span>
            </div>
            <div class="slide next" @click="next">
              <span class="arrow right"></span>
              <span class="arrow right shadow"></span>
            </div>
            <img :src="enclosures[mediaIndex].url" v-if="enclosures[mediaIndex].isImage" />
            <video @loadedmetadata="redo" @click="redo" :src="enclosures[mediaIndex].url" v-if="enclosures[mediaIndex].isVideo" controls />
          </div>
          <div v-else-if="enclosures.length === 1">
            <img :src="enclosures[0].url" v-if="enclosures[0].isImage" />
            <video @loadedmetadata="redo" @click="redo" :src="enclosures[0].url" v-if="enclosures[0].isVideo" controls />
          </div>
        </div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
              <span v-if="introShown">{{intro}} ... <span class="fullContent" @click="showAll">show more</span></span>
              <span class="content" v-else v-html="content"></span>
            </slot>
        </div>
        <div class="social-card-labels">
            <slot name="social-card-labels" class="social-card-labels-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-left" v-if="variant == 'input'">
                <Button variant="icon-wrap"><svgicon name="delete" height="1.5rem" @click.native="remove()"></svgicon></Button>
            </div>
            <div class="float-right">
                <Button variant="icon-wrap" title="Heart" class="confetti-button" @click.native="animateHeart($event)" v-bind:class="{'animated': animatedHeart}" v-if="variant == 'input'"><svgicon name="heart-filled" height="1.5rem" v-if="animatedHeart"/><svgicon name="heart" height="1.5rem" v-else/></Button>
                <Button variant="icon-wrap" title="Pin" class="pin-button" @click.native="animatePin($event)" v-bind:class="{'animated': animatedPin}"><svgicon name="pin" height="1.5rem" class="pin-to-animate"></svgicon></Button>
                <Button variant="icon-wrap" title="Copy to composer" @click.native="toComposer()"><svgicon name="create" height="1.5rem"></svgicon></Button>
            </div>
        </div>
    </Card>

    <Card class="social-card social-card-input" content-spacing="none" v-else-if="variant=='favorite'">
        <div class="social-card-user-info">
            <div class="width-100 relative break-after">
                <div class="float-left">
                    <Avatar />
                </div>
                <div class="float-left user-info-content">
                    <div class="width-100 relative height-100">
                        <div class="flex-content">
                            <div class="width-100">
                                <div class="user-info-content-name">Cas van Grunsven</div>
                                <div class="user-info-content-date">21-11-2019</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="social-card-thumb">
            <div class="social-card-thumb-user">
            </div>
        </div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-left">
            </div>
            <div class="float-right">
                <Button variant="icon-wrap" title="Pin" class="pin-button" @click.native="animatePin($event)" v-bind:class="{'animated': !animatedPin}"><svgicon name="pin" height="1.5rem" class="pin-to-animate"></svgicon></Button>
                <Button variant="icon-wrap" title="Copy to composer"><svgicon name="create" height="1.5rem"></svgicon></Button>
            </div>
        </div>
    </Card>
    <Card class="social-card social-card-suggested" content-spacing="none" v-else-if="variant=='suggested'">
        <div class="social-card-thumb"></div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-labels">
            <slot name="social-card-labels" class="social-card-labels-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-left">
                <Button variant="icon-wrap"><svgicon name="delete" height="1.5rem"></svgicon></Button>
            </div>
            <div class="float-right">
                <Button variant="icon-wrap"><svgicon name="share" height="1.5rem"></svgicon></Button>
            </div>
        </div>
        <div class="social-card-info">
            <div class="row">
                <div class="col-xl">
                    <div class="label-text">Shared by</div>
                    <Avatars></Avatars>
                </div>
            </div>
        </div>
    </Card>
    <Card class="social-card social-card-announcement" content-spacing="none" v-else-if="variant=='announcement'">
        <div class="social-card-thumb"></div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-labels">
            <slot name="social-card-labels" class="social-card-labels-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-right">
                <Button variant="icon-wrap"><svgicon name="delete" height="1.5rem"></svgicon></Button>
            </div>
        </div>
        <div class="social-card-info">
            <div class="row">
                <div class="col-xl">
                    <div class="label-text">Suggested for</div>
                    <Avatars></Avatars>
                </div>
                <div class="col-xl">
                    <div class="label-text">Expiry</div>
                    <div class="width-100 relative">
                        <div class="expiry-date">02-04-2019</div>
                        <div class="expiry-time">16:31</div>
                    </div>
                </div>
            </div>
        </div>
    </Card>
    <Card class="social-card social-card-history" content-spacing="none" v-else-if="variant=='history'">
        <div class="social-card-thumb"></div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-labels">
            <slot name="social-card-labels" class="social-card-labels-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-left">
                <Button variant="icon-wrap"><svgicon name="delete" height="1.5rem"></svgicon></Button>
            </div>
        </div>
        <div class="social-card-info">
            <div class="row">
                <div class="col-xl">
                    <div class="label-text">Shared by 24/78</div>
                    <Avatars></Avatars>
                </div>
                <div class="col-xl">
                    <div class="label-text">Expired on</div>
                    <div class="width-100 relative">
                        <div class="expiry-date">02-04-2019</div>
                        <div class="expiry-time">16:31</div>
                    </div>
                </div>
            </div>
        </div>
    </Card>
    <Card class="social-card social-card-default" content-spacing="none" v-else>
        <div class="social-card-thumb"></div>
        <div class="social-card-text">
            <slot name="social-card-text" class="social-card-text-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-labels">
            <slot name="social-card-labels" class="social-card-labels-inner width-100 relative">
            </slot>
        </div>
        <div class="social-card-actions">
            <div class="float-right">
                <Button variant="icon-wrap"><svgicon name="delete" height="1.5rem"></svgicon></Button>
            </div>
        </div>
        <div class="social-card-info">
            <div class="row">
                <div class="col-xl">
                    <div class="label-text">Suggested for</div>
                    <Avatars></Avatars>
                </div>
                <div class="col-xl">
                    <div class="label-text">Expiry</div>
                    <div class="width-100 relative">
                        <div class="expiry-date">02-04-2019</div>
                        <div class="expiry-time">16:31</div>
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>
<script>
    import Card from '../../components/Card/Card';
    import Button from '../../components/Button/Button';
    import Avatars from '../../components/Avatars/Avatars';
    import Avatar from '../../components/Avatar/Avatar';
    import Item from '@/models/content/Item';
    import Skeleton from '@/components/Skeleton/Skeleton';

    export default {
        name: 'Socialcard',
        components: {
            Card,
            Button,
            Avatars,
            Avatar,
            Skeleton
        },
        props: {
            variant: {
                type: String,
                default: 'default'
            },
            isLiked: {
              type: Boolean,
              default: false
            },
            isPinned: {
              type: Boolean,
              default: false
            },
            showIntro: {
              type: Boolean,
              default: false
            },
            intro: {
              type: String,
              default: ''
            },
            content: {
              type: String,
              default: ''
            },
            hash: {
              type: String,
              default: ''
            }
        },
        data () {
            return {
                animatedPin: false,
                animatedHeart: false,
                fullHidden: true,
                mediaIndex: 0
            }
        },
        computed: {
          introShown() {
            return this.showIntro && this.fullHidden;
          },
          enclosures() {
            return Item.query()
            .where(item => {
              return item.hash === this.hash;
            })
            .all().map(item => {
              return { url: item.enclosure_url, type: item.enclosure_type, isImage: item.isImage, isVideo: item.isVideo };
            });
          }
        },
        mounted () {
          this.animatedHeart = this.isLiked;
          this.animatedPin = this.isPinned;
        },
        methods: {
            prev() {
              this.mediaIndex = (this.mediaIndex === 0) ? this.enclosures.length - 1 : this.mediaIndex - 1;

              this.redo();
            },
            next() {
              this.mediaIndex = (this.mediaIndex === this.enclosures.length-1) ? 0 : this.mediaIndex + 1;

              this.redo();
            },
            showAll() {
              this.fullHidden = false;
                this.redo();
            },
            redo() {
              setTimeout(() => {
                this.$emit('updateLayout')
              }, 100);
            },
            remove() {
              this.$emit('deleteAction');
            },
            animateHeart: function(e) {
                e.preventDefault;
                this.$emit('likeAction');
                this.animatedHeart = !this.animatedHeart;
            },
            animatePin: function(e) {
                e.preventDefault;
                this.$emit('pinAction');
                this.animatedPin = !this.animatedPin;
            },
            getRandomInt(minNumber, maxNumber) {
                return Math.floor(Math.random() * (maxNumber - minNumber) + minNumber);
            },
            toComposer() {
              this.$emit('composerAction');
            }
        }
    }

</script>
<style src="./SocialCard.scss" scoped lang="scss"></style>

